import React from 'react'
import './overlay.css'

export default function OverlayWrapper ({ children, style }) {
  return (
    <div className='fade-overlay' style={style}>
      {children}
    </div>
  )
}
